import { TMeta } from './models';
import { isPhoneError, isError } from './is-error';

export const getCaption = (meta: TMeta, caption = '') => {
    if (isError(meta)) {
        return meta.error || meta.submitError;
    }

    return caption;
};

export const getPhoneCaption = (meta: TMeta, caption = '', value: string) => {
    if (isPhoneError(meta, value)) {
        return meta.error || meta.submitError;
    }

    return caption;
};
